import React, { FunctionComponent } from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import styled from 'styled-components';

export interface LoaderProps {
  size?: number;
  withOpacity: boolean;
}

const StyledDiv = styled.div`
   {
    height: 100vh;
    width: 100vw;
    position: fixed;
    z-index: 2000;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.5);
    overflow-x: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .loader {
    position: relative;
    width: 100%;
    text-align: center;
    margin-bottom: 30px;
    color: #0075c9;
  }
`;
const StyledWithOpacityDiv = styled.div`
   {
    height: 100vh;
    width: 100vw;
    position: fixed;
    z-index: 2000;
    top: 0;
    left: 0;
    opacity: 0.2;
    background-color: rgba(0, 0, 0, 0.5);
    overflow-x: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .loader {
    position: relative;
    width: 100%;
    text-align: center;
    margin-bottom: 30px;
    color: #0075c9;
  }
`;

const SahamLoader: FunctionComponent<LoaderProps> = (props): JSX.Element =>
  props.withOpacity ? (
    <StyledWithOpacityDiv className={'loader-container'}>
      <CircularProgress className="loader" size={props.size || 100} />
    </StyledWithOpacityDiv>
  ) : (
    <StyledDiv className={'loader-container'}>
      <CircularProgress className="loader" size={props.size || 100} />
    </StyledDiv>
  );

export default SahamLoader;
